import React from 'react';
import { Box, Typography } from '@mui/material';
import { Language, Phone, Email } from '@mui/icons-material';
import footerLogo from '../../../Images/footer_log.png';

const PrimaryFooter = () => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: { xs: 'flex-start', sm: 'space-between' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        flexWrap: 'wrap',
        gap: { xs: 1.5, sm: 2, md: 2.5 },
        px: { xs: 1.5, sm: 2, md: 2.5 },
        py: { xs: 1, sm: 1, md: 1.25 },
        backgroundColor: 'transparent',
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: { xs: 'center', sm: 'flex-start' },
          gap: 0.75,
          flexShrink: 0,
          width: { xs: '100%', sm: 'auto' },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.8125rem' },
            background: 'linear-gradient(135deg, #9333EA 0%, #EC4899 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontFamily: '"Inter", sans-serif',
            fontWeight: 500,
          }}
        >
          Powered By
        </Typography>
        <Typography
          sx={{
            fontFamily: '"Inter", sans-serif',
            fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.8125rem' },
            color: '#4A5565',
            fontWeight: 500,
          }}
        >
          HYPERMINDS
        </Typography>
        <Box
          component="img"
          src={footerLogo}
          alt="HYPERMINDS Logo"
          sx={{
            height: { xs: 18, sm: 20, md: 22 },
            width: 'auto',
            objectFit: 'contain',
            ml: 0.5,
          }}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 1, sm: 1.5, md: 2 },
          flexWrap: 'wrap',
          flexShrink: 1,
          minWidth: 0,
          width: { xs: '100%', sm: 'auto' },
          justifyContent: { xs: 'flex-start', sm: 'center' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <Language
            sx={{
              fontSize: { xs: '0.875rem', sm: '0.875rem', md: '0.9375rem' },
              color: '#9CA3AF',
            }}
          />
          <Typography
            component="a"
            href="https://www.hyperminds.tech"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: '0.7rem', sm: '0.8125rem', md: '0.8125rem' },
              color: '#4A5565',
              textDecoration: 'none',
              wordBreak: 'break-all',
              overflowWrap: 'break-word',
              '&:hover': {
                color: '#383838',
                textDecoration: 'underline',
              },
              transition: 'color 0.2s ease',
            }}
          >
            https://www.hyperminds.tech
          </Typography>
        </Box>

        <Box
          sx={{
            width: '1px',
            height: { xs: '14px', sm: '16px', md: '18px' },
            backgroundColor: '#9333EA',
            opacity: 0.3,
            display: { xs: 'none', sm: 'block' },
          }}
        />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <Phone
            sx={{
              fontSize: { xs: '0.875rem', sm: '0.875rem', md: '0.9375rem' },
              color: '#9CA3AF',
            }}
          />
          <Typography
            component="a"
            href="tel:+919109799591"
            sx={{
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.8125rem' },
              color: '#4A5565',
              textDecoration: 'none',
              '&:hover': {
                color: '#383838',
                textDecoration: 'underline',
              },
              transition: 'color 0.2s ease',
            }}
          >
            +919109799591
          </Typography>
        </Box>

        <Box
          sx={{
            width: '1px',
            height: { xs: '14px', sm: '16px', md: '18px' },
            backgroundColor: '#9333EA',
            opacity: 0.3,
            display: { xs: 'none', sm: 'block' },
          }}
        />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <Email
            sx={{
              fontSize: { xs: '0.875rem', sm: '0.875rem', md: '0.9375rem' },
              color: '#9CA3AF',
            }}
          />
          <Typography
            component="a"
            href="mailto:info@hyperminds.tech"
            sx={{
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.8125rem' },
              color: '#4A5565',
              textDecoration: 'none',
              '&:hover': {
                color: '#383838',
                textDecoration: 'underline',
              },
              transition: 'color 0.2s ease',
            }}
          >
            info@hyperminds.tech
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          flexShrink: 1,
          minWidth: 0,
          maxWidth: '100%',
          width: { xs: '100%', sm: 'auto' },
          textAlign: { xs: 'center', sm: 'right' },
        }}
      >
        <Typography
          sx={{
            fontFamily: '"Inter", sans-serif',
            fontSize: { xs: '0.7rem', sm: '0.8125rem', md: '0.8125rem' },
            color: '#6A7282',
            fontWeight: 400,
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          © 2024 Dataverse. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default PrimaryFooter;
